import { Component, Input, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { isEmbeddableHttpUrl } from "../../../../../../../../common/passport/video-embed.util";

@Component({
  selector: "app-product-details",
  templateUrl: "./product-details.component.html",
  styleUrls: ["./product-details.component.scss"],
})
export class ProductDetailsComponent implements OnInit {
  @Input("workflowDescription") workflowDescription: string;
  @Input("product") product: any;
  @Input("productData") productData: any

  productExtras: any;
  productHighlights:any[] = [];

  productBanner:any;
  productList:any = [];
  productVideos:any = [];
  productProvider:any = [];

  constructor(private router: Router,public sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.handleProductExtraData()
  }

  navigateToRatingsPage() {
    this.router.navigate(["products/ratings"]);
  }

  goToRRSS(url: string) {
    window.open(url, "_blank");
  }

  openInstagramVideo(url: string) {
    window.open(url, "_blank");
  }
  handleProductExtraData() {
    // productData comes from JSON.parse(product.extraDataJson) in product.page.ts.
    // JSON.parse(null) returns null without throwing, so a product whose extraDataJson
    // is not published reaches this component as null/undefined - same reason the sibling
    // *ngIf="productData" guard exists in product-body.component.html. Guard against
    // productData missing, productData.extras missing, and extras.elements not being an
    // array (any shape other than the one product-body/passport-essentials-cards expect).
    // When there is no enriched content the tab simply renders nothing extra - the
    // highlight/list/video/provider arrays stay empty - rather than showing invented data.
    const elements = this.productData?.extras?.elements

    if (!Array.isArray(elements)) {
      this.productExtras = null
      return
    }

    this.productExtras = this.productData.extras
    elements.map((extra:any)=>{
      if(extra.type == "highlight"){
        this.productHighlights.push(extra);
      }
      if(extra.type == "banner"){
        this.productBanner = extra;
      }
      if(extra.type == "list"){
        this.productList.push(extra);
      }
      if(extra.type == "video"){
        this.productVideos.push(extra);
      }
      if(extra.type == "provider"){
        this.productProvider = extra;
      }
    })
  }

  formateVideoURL(link:string){
    let videoEmbedUrl = '';
    // extraDataJson is tenant-authored: a video element can arrive with no link at all.
    if (!link) return null

    const videoUrl = link;
    
    // Regex patterns for different video platforms
    const youtubeRegex = /^(https?\:\/\/)?(www\.)?(youtube|youtu|youtube-nocookie)\.(com|be)\/(watch\?v=|embed\/|v\/)?([a-zA-Z0-9_-]{11})/;
    const vimeoRegex = /^(https?\:\/\/)?(www\.)?(vimeo)\.com\/(\d+)($|\/)/;
    const dailymotionRegex = /^(https?\:\/\/)?(www\.)?(dailymotion)\.com\/video\/(\w+)(.*)/;
    const instagramRegex = /(?:https?:\/\/)?(?:www\.)?instagram\.com\/(?:p|reel|tv)\/([a-zA-Z0-9_-]+)/;
    const directVideoRegex = /\.(mp4|ogg|webm)$/i;
    
    // Check for YouTube
    if (videoUrl.match(youtubeRegex)) {
      const youtubeMatch = videoUrl.match(youtubeRegex);
      if (youtubeMatch) {
        videoEmbedUrl = `https://www.youtube.com/embed/${youtubeMatch[6]}`;
      }
    }
    // Check for Vimeo
    else if (videoUrl.match(vimeoRegex)) {
      videoEmbedUrl = videoUrl.replace(vimeoRegex, 'https://player.vimeo.com/video/$4');
    }
    // Check for Dailymotion
    else if (videoUrl.match(dailymotionRegex)) {
      videoEmbedUrl = videoUrl.replace(dailymotionRegex, 'https://www.dailymotion.com/embed/video/$4');
    }
    // Check for Instagram
    else if (videoUrl.match(instagramRegex)) {
      const instagramMatch = videoUrl.match(instagramRegex);
      if (instagramMatch) {
        // Determine Instagram post type and convert to embed format
        if (videoUrl.includes('/reel/')) {
          videoEmbedUrl = `https://www.instagram.com/reel/${instagramMatch[1]}/embed/`;
        } else if (videoUrl.includes('/tv/')) {
          videoEmbedUrl = `https://www.instagram.com/tv/${instagramMatch[1]}/embed/`;
        } else {
          // Regular post
          videoEmbedUrl = `https://www.instagram.com/p/${instagramMatch[1]}/embed/`;
        }
      }
    }
    // Check for direct video files
    else if (videoUrl.match(directVideoRegex)) {
      videoEmbedUrl = videoUrl;
    }
    // No known platform: keep the link as given and let the http(s) guard below decide.
    else {
      videoEmbedUrl = videoUrl;
    }
    
    // The four platform branches above build the embed URL themselves from a matched id,
    // so they are always an absolute https URL of ours. The direct-video branch and the
    // no-match fallback pass tenant-authored text straight through, and that text reaches
    // an <iframe src> - which is exactly where a `javascript:` or `data:text/html` link
    // written in the backoffice would execute in the browser of whoever scans the QR.
    if (!isEmbeddableHttpUrl(videoEmbedUrl)) return null

    // The bypass is unavoidable - Angular blocks every resource URL in an <iframe src>
    // otherwise - and the isEmbeddableHttpUrl guard above is what makes it safe: only
    // http(s) reaches this line, so the audit rule below is suppressed deliberately.
    // nosemgrep: typescript.angular.security.audit.angular-domsanitizer.angular-bypasssecuritytrust
    return this.sanitizer.bypassSecurityTrustResourceUrl(videoEmbedUrl)
  }

  isInstagramVideo(link: string): boolean {
    const instagramRegex = /(?:https?:\/\/)?(?:www\.)?instagram\.com\/(?:p|reel|tv)\/([a-zA-Z0-9_-]+)/;
    return instagramRegex.test(link);
  }
}
